import { apiEmpleo } from "../../util/ApiEmpleo";

export const apiDeleteUserFavoriteCandidate = async (id: string) => {
  let res = await apiEmpleo.delete(`user-favorite-candidates/${id}`);

  return res;
};
